import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8c2eb0c0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = {
  class: "btn"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("最新发布");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("最多浏览");

const _hoisted_8 = {
  class: "content"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "view"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202508/6f8b4e529adb4ead81711f0205f9507d.png",
  alt: ""
}, null, -1));

const _hoisted_12 = {
  class: "title-box"
};
const _hoisted_13 = {
  key: 1,
  class: "tag"
};
const _hoisted_14 = {
  class: "time-box"
};
const _hoisted_15 = {
  key: 0,
  class: "author"
};
const _hoisted_16 = {
  class: "time"
};
import dayjs from 'dayjs';
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    menuName: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['search', 'clear', 'update:searchVal', 'goDetails', 'sortChange'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const dataList = computed(() => props.data.slice(0, 8));
    const newsName = ref('');
    const selectLabel = ref('最新发布');
    const defaultCoverImg = inject('defaultImg');

    const handleSearch = () => {
      emits('update:searchVal', newsName.value);
      emits('search');
    };

    const handleClear = () => {
      emits('update:searchVal', '');
      emits('clear');
    };

    const goDetails = item => {
      emits('goDetails', item);
    };

    const handleCommand = command => {
      selectLabel.value = command === '1' ? '最新发布' : '最多浏览';
      emits('sortChange', command);
    };

    return (_ctx, _cache) => {
      const _component_arrow_down = _resolveComponent("arrow-down");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      const _component_el_input = _resolveComponent("el-input");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(__props.menuName), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_dropdown, {
        placement: "bottom",
        trigger: "click",
        onCommand: handleCommand
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "1"
          }, {
            default: _withCtx(() => [_hoisted_6]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "2"
          }, {
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString(selectLabel.value) + " ", 1), _createVNode(_component_el_icon, {
          class: "el-icon--right"
        }, {
          default: _withCtx(() => [_createVNode(_component_arrow_down)]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_input, {
        modelValue: newsName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => newsName.value = $event),
        class: "search-input",
        clearable: "",
        placeholder: "搜索课程名称",
        onClear: handleClear,
        onKeyup: _withKeys(handleSearch, ["enter"])
      }, {
        prefix: _withCtx(() => [_createElementVNode("i", {
          class: "iconfont icon-sousuo search-icon",
          onClick: handleSearch
        })]),
        _: 1
      }, 8, ["modelValue", "onKeyup"])])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "item",
          onClick: $event => goDetails(item)
        }, [_createElementVNode("div", {
          class: "img-box",
          style: _normalizeStyle({
            backgroundImage: `url(${item.cover_url || _unref(defaultCoverImg)})`
          })
        }, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", null, _toDisplayString(item.view_num), 1)])], 4), _createElementVNode("div", _hoisted_12, [item.news_name ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          style: _normalizeStyle({
            width: !item.source ? '100%' : '70%'
          }),
          class: "title"
        }, _toDisplayString(item.news_name), 5)) : _createCommentVNode("", true), item.source ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.source), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_14, [item.original_auth ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.original_auth), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_16, "发布时间：" + _toDisplayString(_unref(dayjs)(item.publish_time).format('YYYY-MM-DD')), 1)])], 8, _hoisted_9);
      }), 128))])), [[_directive_loading, __props.loading]])]);
    };
  }

};